import { render, staticRenderFns } from "./OrgApiKeys.vue?vue&type=template&id=7279f693&scoped=true"
import script from "./OrgApiKeys.vue?vue&type=script&lang=js"
export * from "./OrgApiKeys.vue?vue&type=script&lang=js"
import style0 from "./OrgApiKeys.vue?vue&type=style&index=0&id=7279f693&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7279f693",
  null
  
)

export default component.exports